import NewFinanceStaticDashboard from "components/finance/NewFinanceStaticDashboard";

const NewFinance = ({ currentMember, permissionsLoaded }) => {
  return <NewFinanceStaticDashboard scope="organization" currentMember={currentMember} permissionsLoaded={permissionsLoaded} />;
};

export default NewFinance;
